/**
 * 基础配置信息 VIP托管
 * @type {{cityCode: string, appId: string, source: string}}
 */
const ENV = process.env.NODE_ENV === "beta" ? 'beta' : 'prod';

const appid = {
  beta: '960740273',
  prod: '1985499084'
}

export const config = {
  appId: appid[ENV],
};

